module.exports = __webpack_public_path__ + "static/media/quilv.86a4ae00.jpg";